import { render, staticRenderFns } from "./SignatureBlock.vue?vue&type=template&id=69c6d1ca&scoped=true&"
import script from "./SignatureBlock.vue?vue&type=script&lang=js&"
export * from "./SignatureBlock.vue?vue&type=script&lang=js&"
import style0 from "./SignatureBlock.vue?vue&type=style&index=0&id=69c6d1ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c6d1ca",
  null
  
)

export default component.exports